import './ServicesIntro.scss'
import React from 'react'
import type { ResponsiveImageType } from 'react-datocms'
import { EagerDatoImage } from '#src/components/image/EagerDatoImage.js'

interface ServicesIntroProps {
  description?: string
  'aria-hidden'?: boolean
  image: ResponsiveImageType
}

export function ServicesIntro(props: ServicesIntroProps) {
  return (
    <section className="services__intro" aria-hidden={props['aria-hidden']}>
      <div className="services__intro_inner-container">
        <div className="services__text">
          <h1 className="services__description">{props.description}</h1>
        </div>
        <div className="services__image-container">
          <EagerDatoImage
            className="services__image"
            responsiveImage={props.image}
            sizes={['(max-width: 992px) 100vw', '80vw']}
          />
        </div>
      </div>
    </section>
  )
}
